import React from 'react';
import { motion } from 'framer-motion';
import ContactForm from '../components/ContactFormElevated';
import ParallaxBackground from '../components/ParallaxBackground';

const AgentsLenders = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="min-h-screen"
    >
      <ParallaxBackground 
        image="/images/boathouse-row.jpg"
        className="py-32"
        overlay={true}
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 text-white">
            Real Estate Agents and Lenders
          </h1>
          <p className="text-xl md:text-2xl text-gray-200 max-w-3xl mx-auto">
            Comprehensive closing services for real estate professionals
          </p>
        </div>
      </ParallaxBackground>

      <section className="py-16 bg-eagle-light-gray">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold text-eagle-dark mb-4">
              Real Estate Agents and Lenders Services
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto">
              As a real estate agent or lender, you play a crucial role in the real estate transaction process. At Eagle Closing, we offer comprehensive closing services tailored specifically to meet the needs of real estate agents and lenders. Our goal is to provide seamless and efficient closing experiences for you and your clients.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {[
              {
                title: 'Efficient Transaction Coordination',
                description: 'Our experienced team acts as a central point of contact, coordinating all aspects of the closing process. We work closely with you, the buyer, seller, attorneys, and other parties involved to ensure a smooth and timely closing.',
              },
              {
                title: 'Clear Communication',
                description: 'We prioritize clear and timely communication throughout the transaction. Our team keeps you informed about important milestones, documents needed, and any potential issues that may arise, allowing you to provide the best service to your clients.',
              },
              {
                title: 'Document Preparation and Review',
                description: 'We handle the preparation and review of all necessary closing documents, including contracts, addendums, and closing statements. Our attention to detail ensures accuracy and compliance with legal requirements.',
              },
              {
                title: 'Title Examination and Insurance',
                description: 'We conduct thorough title examinations and assist in obtaining title insurance, providing protection and peace of mind for you and your clients regarding the property\'s ownership and any potential title issues.',
              },
              {
                title: 'Timely and Efficient Closings',
                description: 'We understand the importance of meeting deadlines. With our streamlined processes and commitment to efficiency, we work diligently to ensure that closings are conducted in a timely manner, allowing you to provide exceptional service to your clients.',
              },
            ].map((service, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: index * 0.1 }}
                className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
              >
                <h3 className="text-xl font-semibold text-eagle-dark mb-3">
                  {service.title}
                </h3>
                <p className="text-gray-600">
                  {service.description}
                </p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-8">
            <p className="text-lg text-gray-700 mb-8">
              At Eagle Closing, we value the relationships we build with real estate agents and lenders. We strive to provide exceptional service, support, and expertise to help you achieve successful closings for your clients.
            </p>
            <p className="text-lg text-gray-700 mb-8">
              Contact us today to learn more about our services for real estate agents and lenders and how we can assist you in achieving seamless and efficient closings. Trust Eagle Closing to be your trusted partner throughout the closing process, ensuring a smooth transaction and a satisfied clientele.
            </p>
          </div>
        </div>
      </section>
      
      {/* Contact Form with Parallax */}
      <ContactForm backgroundImage="/images/benjamin-franklin-bridge.jpg" />
    </motion.div>
  );
};

export default AgentsLenders;

